module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__1-d56c48413fe8cf5b7b90b397a070ce20.png";